import {
  onboardingStepKindByKey,
  type OnboardingStepDto,
  type OnboardingStepKey,
} from '@osteopro/shared';
import { ONBOARDING_STEP_PATHS } from './steps.js';

/** Page de mise en route tant que des étapes obligatoires restent, ou tant que la liste n'est pas masquée. */
export const MANDATORY_ONBOARDING_PATH = '/mise-en-route';

/**
 * Étapes obligatoires encore à faire par ce membre. La nature vient de
 * `onboardingStepKindByKey` (identité avec logo, autorisation, IBAN, types) ;
 * « fait » vient du serveur. Les horaires sont facultatifs : ils ne retiennent personne.
 * Une étape réservée au titulaire ne bloque pas qui ne peut pas la régler.
 */
export function pendingMandatorySteps(steps: readonly OnboardingStepDto[]): OnboardingStepDto[] {
  return steps.filter(
    (step) =>
      onboardingStepKindByKey[step.key] === 'required' && !step.done && step.actionable,
  );
}

/** Vrai quand chaque étape de nature obligatoire est faite, qu'elle soit actionnable ou non. */
export function allRequiredStepsDone(steps: readonly OnboardingStepDto[]): boolean {
  return steps
    .filter((step) => onboardingStepKindByKey[step.key] === 'required')
    .every((step) => step.done);
}

const MANDATORY_DESTINATIONS: readonly string[] = (
  Object.entries(ONBOARDING_STEP_PATHS) as [OnboardingStepKey, string][]
)
  .filter(([key]) => {
    const kind = onboardingStepKindByKey[key];
    return kind === 'required' || kind === 'optional';
  })
  .map(([, path]) => path);

/**
 * Pendant que des étapes obligatoires restent, cette page et les écrans des étapes obligatoires
 * ou facultatives restent ouverts : on peut encore remplir les horaires. Les premières actions
 * (patient, agenda, facture) restent fermées. `/settings` redirige vers le profil, où se saisit
 * le numéro d'autorisation.
 */
export function isMandatoryOnboardingPath(path: string): boolean {
  const pathname = path.split('?')[0] ?? path;
  if (pathname === MANDATORY_ONBOARDING_PATH || pathname === '/settings') return true;
  return MANDATORY_DESTINATIONS.some((destination) => pathname === destination);
}
